import { IDisplaySchema } from './i-display-schema';
import { ListFooter } from './list-footer';
import { ListGroup } from './list-group';
import { SummitIdObject } from './summit-id-object';

const debugging = false;

export class SummitListFunctions {
  public static filterPredicate<T extends SummitIdObject>(
    columnList: (keyof T)[] | undefined,
    data: T | unknown | ListGroup<T> | ListFooter<T>,
    lclFilter: string | undefined,
    displayDetails: IDisplaySchema<T>
  ) {
    if (!columnList || !data) {
      return false;
    }
    if (lclFilter === '*') {
      return true;
    }
    if (debugging) console.log(`[SummitList] Filter Processing for ${lclFilter}`);

    let values: string | null = null;
    if (columnList) {
      if (debugging) console.log(`Active filter ${columnList.join(',')}`);
      const isGroup = (data as any).isGroup;
      const isGroupFooter = (data as any).isGroupFooter;
      if (!isGroup && !isGroupFooter) {
        if (debugging) console.log(`Individual`, data, columnList);
        values = columnList
          .map((columnName) => displayDetails.getAttribute(columnName))
          .filter((attribute) => attribute != null)
          .reduce(
            (lclValues, attribute) =>
              (lclValues += displayDetails.getTextLabel(data as T, attribute)?.toString() + ';'),
            ''
          );
      } else if (isGroup || isGroupFooter) {
        if (debugging) console.log(`Group ${(data as any).groupId}`, data);
        let response = false;
        (data as any).elements.forEach((element: T) => {
          if (!response && SummitListFunctions.filterPredicate(columnList, element, lclFilter, displayDetails)) {
            response = true;
          }
        });
        return response;
      }
    }
    // console.log(`Filtering for ${lclFilter} in ${values}`);
    if (values?.toLowerCase().includes(lclFilter?.toLowerCase() ?? '')) {
      // console.log(`Filter Processing for ${lclFilter} with True in ${values}`, data);
      return true;
    }
    // console.log(`Filter Processing for ${lclFilter} with False in ${values}`, data);
    return false;
  }
}
